import sanitizer, { DisallowedTagsModes } from "sanitize-html";

const globalConfiguration = {
  allowedTags: ["br", "pre", "a", "span", "p"],
  disallowedTagsMode: "discard" as DisallowedTagsModes,
  selfClosing: ["br"],
};

export const sanitize = (dirtyHTML: string) => {
  return sanitizer(dirtyHTML, globalConfiguration);
};

export const sanitizeMarkdown = (dirtyHTML: string) => {
  const settings: sanitizer.IOptions = {
    allowedTags: ["h1", "h2", "pre", "code", "h3", "h4", "h5", "h6", "p", "b", "i", "em", "strong", "ul", "ol", "li", "a", "br", "blockquote", "table", "thead", "tbody", "tr", "th", "td"],
    allowedAttributes: {
      a: ["href", "target", "rel"],
    },
    disallowedTagsMode: "escape" as DisallowedTagsModes,
    allowedStyles: {},
    transformTags: {
      a: (tagName: any, attribs: any) => {
        return {
          tagName: "a",
          attribs: {
            href: attribs.href,
            target: "_blank",
            rel: "noopener noreferrer",
          },
        };
      },
    },

    allowedIframeHostnames: [],

    allowedScriptTags: [],
  };
  return sanitizer(dirtyHTML, settings);
};
